/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useState } from "react";
import { BEM } from "@adapptio/lib-components";

import "./ReferenceGuideSidebar.scss";
import { SearchBox, SEARCHBOX_SIZE, SEARCHBOX_STYLE } from "../../../../../ui/components/SearchBox";
import { ReferenceGuideSidebarNav } from "../ReferenceGuideNav/ReferenceGuideSidebarNav";
import { ReferenceGuide } from "../../ReferenceGuide";
import { TReferenceData } from "../../ReferenceGuideTypes";

export interface IReferenceGuideSidebarProps {
	className?: string;
	nav: TReferenceData[];
	updateNav: () => void;
	selected: TReferenceData;
	setSelected: (select: TReferenceData) => void;
	view: ReferenceGuide;
}

export const ReferenceGuideSidebar: React.FC<IReferenceGuideSidebarProps> = ({
	className,
	nav,
	updateNav,
	setSelected,
	selected,
	view
}) => {
	const baseClass = BEM("edt-reference-sidebar-main");

	const [ value, setValue ] = useState("");

	const handleSearch = (value) => {
		setValue(value);
		updateNav();
		view.searchReference(value);
	};

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<SearchBox
				value={value}
				onChange={handleSearch}
				size={SEARCHBOX_SIZE.SMALL}
				style={SEARCHBOX_STYLE.FIELD_NAKED_ROUND}
				placeholder="Search..."
			/>
			{nav.map((item, index) => (
				<ReferenceGuideSidebarNav
					key={index}
					data={item}
					selected={selected}
					setSelected={setSelected}
				/>
			))}
		</div>
	);
};
